import React from "react";
import { cn } from "../../../utils/tw";
import { theme } from "../../../theme/tokens";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  multiline?: boolean;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ multiline, className, ...props }, ref) => {
    if (multiline) {
      return (
        <textarea
          ref={ref as any}
          className={cn("border px-3 py-2 focus:outline-primary", className)}
          style={{ borderColor: theme.colors.border, borderRadius: theme.radius.md }}
          {...(props as any)}
        />
      );
    }
    return (
      <input
        ref={ref}
        className={cn("border px-3 py-2 focus:outline-primary", className)}
        style={{ borderColor: theme.colors.border, borderRadius: theme.radius.md }}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export default Input;
